import { Navigate } from 'react-router-dom';
import { authService } from '@/services/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  if (!authService.isAuthenticated() || authService.isTokenExpired()) {
    authService.clearAuth();
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
